import Vue      from 'vue';
import axios    from '@/services/axios';
import Auth     from '@/services/auth'
import Vuex     from 'vuex';
import moment   from 'moment';

Vue.use(Vuex);

let initialState = {
  
    pending:          false,
    devMode:          false,
    
    messages:         [],
    
    trainingsPlans:   [],
    trainings:        [],
    trainingsFetched: false,
    workouts:         [],
    
    activeWorkout:    null,
    
    currentUser:      Auth.from(localStorage.token),
    
    
    token:            undefined,
    loginError:       '',
    isLoggedIn:       !!localStorage.getItem('token'),
  
}

export default new Vuex.Store({
  state: initialState,
  // ------------------------------------------------------------------------------------------------
  //  =>  S T O R E  ::     M U T A T I O N S
  // ------------------------------------------------------------------------------------------------
  mutations: {
    
    INITIALISE_STORE(state){
      console.log('INIT STATE')
      if(localStorage.getItem('store')){
        let oldState = Object.assign(state, JSON.parse(localStorage.getItem('store')))
        oldState.pending = false
        this.replaceState(
          oldState
        )
        state.loginErrors = []
      }
    },
    
    SET_MESSAGE(state, payload){
      state.messages.push({
        type: payload.type || "info",
        text: payload.text,
        time: moment(),
        id:   moment().format("x") + '#' + Math.ceil(Math.random() * 9)
      })
    },
    REMOVE_MESSAGE(state,payload){
      console.log("REMOVE_MESSAGE", payload, state.messages.length)
      for(let i = 0; i < state.messages.length; i++){
        console.log("REMOVE_MESSAGE", state.messages[i].time, payload.time)
        if ( state.messages[i].id === payload.id) {
          state.messages.splice(i, 1)
          return true
        }
      }
      return false
    },
    REMOVE_ALL_MESSAGES(state) {
      state.messages = []
    },
    
    RESET_STORE(state){
      console.log("RESET_STORE")
      state = initialState
    },
    
    
    LOGIN(state, payload){
      state.pending = true
    },
    LOGOUT(state) {
      state.pending = false
      state.isLoggedIn = false
      state.currentUser = undefined
    },
    LOGIN_SUCCESS(state, payload){
      console.log('LOGIN SUCCESS', payload);
      localStorage.token = payload.token
      axios.defaults.headers['Authorization'] = 'Bearer ' + localStorage.token;
      state.pending = false
      state.isLoggedIn = true
      state.currentUser = Auth.from(localStorage.token)
    },
    LOGIN_ERROR(state, payload){
      console.log('set logon errors', payload);
      state.pending = false
      state.isLoggedIn = false
      state.loginErrors = payload
    },
    
    SET_TRAININGS_PLANS(state, payload){
      state.trainingsPlans = payload
    },
    SET_TRAININGS(state, payload){
      state.trainings = payload
    },
    SET_TRAININGS_FETCHED(state, payload){
      state.trainingsFetched = payload
    },
    
    
    SET_ACTIVE_WORKOUT(state, payload){
      Vue.set(state, 'activeWorkout', payload)
    },
    UNSET_ACTIVE_WORKOUT(state){
      Vue.set(state, 'activeWorkout', null)
    },
    
    SET_CURRENT_SET(state, payload) {
      Vue.set(state.activeWorkout, 'currentSet', payload)
    },
    SET_CURRENT_TRAINING(state, payload) {
      Vue.set(state.activeWorkout, 'currentTraining', payload)
    },
    
    SET_WORKOUT_ID(state, payload) {
      Vue.set(state.activeWorkout, 'id', payload)
    },
    
    ADD_EXCERCISE(state, payload) {
      let excercises = [].concat( state.activeWorkout.excercises, payload )
      Vue.set(state.activeWorkout, 'excercises', excercises)
    },
    
    FINISH_WORKOUT(state) {
      Vue.set(state.activeWorkout, 'currentSet', null )
      Vue.set(state.activeWorkout, 'currentTraining', null )
      Vue.set(state.activeWorkout, 'finished_at', moment() )
      Vue.set(state.activeWorkout, 'done', true )
    },
    
    UPDATE_SETTINGS(state, payload) {
      Vue.set( state.currentUser, 'level', payload.level )
      Vue.set( state.currentUser, 'day_ends_at', payload.day_ends_at )
      Vue.set( state.currentUser, 'countdown', payload.countdown )
      Vue.set( state.currentUser, 'app_style', payload.app_style )
    }
    
  },
  // ------------------------------------------------------------------------------------------------
  //  =>  S T O R E  ::     A C T I O N S
  // ------------------------------------------------------------------------------------------------
  actions: {
    
    login({commit}, credentials){
      commit('LOGIN')
      return axios.post('/auth', credentials)
      .then((response) => {
        console.log('login response',  response);
        if (response.data.errors)     { commit('LOGIN_ERROR', response.data.errors) }
        if (response.status === 200)  { commit('LOGIN_SUCCESS', response.data) }
        return response
      })
      .catch((error) => {
        console.log('login response', error, error.data.error.base);
        commit('LOGIN_ERROR', error.data.error.base)
        // return error
        return Promise.reject(error);
      })
    },
    logout({commit}){
      // localStorage.removeItem('jwt')
      localStorage.removeItem('token')
      localStorage.removeItem('store')
      this.replaceState( initialState )
      commit('LOGOUT')
    },
    
    resetData({commit}) {
      localStorage.removeItem('store')
      commit('SET_TRAININGS_PLANS', [])
      commit('SET_TRAININGS', [])
      commit('SET_TRAININGS_FETCHED', false)
    },
    
    setMessage({commit}, msg) {
      let message = {
        text: msg.text,
        type: msg.type
      }
      commit('SET_MESSAGE', message)
    },
    removeMessage({commit}, msg) {
      console.log("removeMessage store", msg)
      commit('REMOVE_MESSAGE', msg)
    },
    removeAllMessages({commit}) {
      console.log("removeAllMessages store")
      commit('REMOVE_ALL_MESSAGES')
    },
    
    getPlans({commit}) {
      console.log("STORE getPlans: ");
      commit('SET_TRAININGS_FETCHED', false)
      axios.get("/trainings_plans").then((response) => {
        console.log("fetched trainings_plans: ", response);
        commit('SET_TRAININGS_PLANS', response.data.data)
        commit('SET_TRAININGS', response.data.included)
        commit('SET_TRAININGS_FETCHED', true)
      }).catch((error) => {
        console.log( "API-ERROR: trainings_plans", error);
        commit('SET_TRAININGS_FETCHED', false)
      });
    },
    
    setActiveWorkout({commit}, wrkt) {
      commit('SET_ACTIVE_WORKOUT', wrkt)
      axios.post("/workouts", wrkt ).then((response) => {
        console.log("API: create Workout", response);
        commit('SET_WORKOUT_ID', response.data.data.id)
      }).catch((error) => {
        console.log( "API-ERROR: create Workout ", error);
      });
    },
    
    
    updateSettings({commit}, settings) {
      commit('UPDATE_SETTINGS', settings)
      axios.post("/settings", {settings: settings}).then((response) => {
        console.log("API: update Settings", response);
      }).catch((error) => {
        console.log( "API-ERROR: update Settings", error);
      });
    },
    
    unsetActiveWorkout({commit, getters}) {
      let wrkID = getters.getActiveWorkout ? getters.getActiveWorkout.id : false
      if (wrkID) {
        axios.delete("/workouts/" + wrkID ).then((response) => {
          console.log("API: delete Workout", response);
        }).catch((error) => {
          console.log( "API-ERROR: delete Workout", error);
        });
      }
      commit('UNSET_ACTIVE_WORKOUT')
    },
    
    setCurrentSet({commit}, that) {
      commit('SET_CURRENT_SET', that)
    },
    
    setCurrentTraining({commit}, trng) {
      commit('SET_CURRENT_TRAINING', trng)
    },
    
    addExcercise({commit}, excercise) {
      commit('ADD_EXCERCISE', excercise)
      axios.post("/workout_trainings", excercise ).then((response) => {
        console.log("workout_trainings - API: ", response);
      }).catch((error) => {
        console.log( "workout_trainings - API - ERROR: ", error);
      });
    },
    
    finishWorkout({commit}) {
      commit('FINISH_WORKOUT')
    }
    
  },
  // ------------------------------------------------------------------------------------------------
  //  =>  S T O R E  ::     G E T T E R S
  // ------------------------------------------------------------------------------------------------
  getters: {
    
    currentUser(state){
      return state.currentUser || false
    },
    getActiveWorkout(state) {
      return state.activeWorkout || false
    },
    
    getMessages(state){
      return state.messages
    },
    
    getTraining(state) {
      //# https://github.com/vuejs/vuex/issues/688
      
      // return that => state.trainings.filter(item =>{
      //   return (item.id === that.id) && (item.type === that.type)
      // })[0];
      return that => {
        // console.log("getTraining", that.type, that.id)
        for (let i = 0; i < state.trainings.length; i++) { 
          let item = state.trainings[i]
          if ( (item.id === that.id) && (item.type === that.type) ) {
            return item
          }
        }
        return false
      };
      
    },
    
    getTrainingsPlans(state) {
      return state.trainingsPlans
    },
    getTrainings(state) {
      return state.trainings
    },
    trainingsFetched(state) {
      return state.trainingsFetched
    },
    
    activeWorkout(state) {
      return state.activeWorkout
    },
    
    
  }
});
